import React from "react";
import classnames from "classnames";

import "./LinkCard.css";

export const LinkCardContainer = ({ children }) => (
  <div className="link-card-container">
    {children}
  </div>
);

export const LinkCard = ({ id, href, img, label, description }) => {
  const className = classnames("link-card", id);
  return (
    <a href={href} className={className}>
      <div className="link-card-top">
        <img src={img} className="link-card-image" alt={label} />
      </div>
      <div className="link-card-bottom">
        <span className="link-card-description">{description}</span>
        <span className="btn btn-primary-small link-card-button">{label}</span>
      </div>
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/components/LinkCard.js